// import { SearchPage } from '../../page-components/search/search';
//
// export default SearchPage;
import { SearchSwitch } from '../../page-components/search/SearchPage2';
import { NextPage, NextPageContext } from 'next';
import React from 'react';
import { SSRPageProps, SSRPageProvider } from '../../components/SSRPage/SSRPage';

const Page: NextPage<any> = (props) => <SSRPageProvider props={props} SSRComp={SearchSwitch} />;

Page.getInitialProps = (context: NextPageContext) => SSRPageProps(SearchSwitch, context);

export default Page;
